import React from "react";
import { useTranslation } from "react-i18next";
import { qualityColor } from "../../../utils/road";
import { gradeOf } from "../../../utils/netquality";
import styles from "../../network_map/network_map.module.css";

const PERIOD_KEY = { 1: "day", 7: "week", 30: "month" };

// "1 camión" / "5 camiones": una clave por forma, sin depender de los plurales de i18next.
function plural(t, key, n) {
  return t(`roadmap.kpi.${key}${n === 1 ? "One" : ""}`, { n: n.toLocaleString() });
}

function Delta({ summary, t }) {
  if (!summary || summary.score === null || summary.score === undefined) return null;
  if (summary.prev_score === null || summary.prev_score === undefined) {
    return <span className={`${styles.kpiDelta} ${styles.kpiDeltaNeutral}`}>{t("roadmap.kpi.noPrevious")}</span>;
  }
  const d = summary.delta ?? 0;
  if (Math.abs(d) < 1) return <span className={`${styles.kpiDelta} ${styles.kpiDeltaNeutral}`}>{t("roadmap.kpi.flat")}</span>;
  const up = d > 0;
  return (
    <span className={`${styles.kpiDelta} ${up ? styles.kpiDeltaUp : styles.kpiDeltaDown}`}>
      {up ? "▲" : "▼"} {up ? "+" : "−"}{Math.abs(Math.round(d))} {t("roadmap.kpi.vsPrevious")}
    </span>
  );
}

export default function RoadKpi({ summary, days }) {
  const { t } = useTranslation();
  if (!summary || !summary.n) return null;
  const score = summary.score;
  return (
    <div className={styles.kpi} role="group" aria-label={t("roadmap.kpi.title")}>
      <div className={styles.kpiHero}>
        <div className={styles.kpiLabel}>{t("roadmap.kpi.title")} · {t(`roadmap.periods.${PERIOD_KEY[days] || "week"}`)}</div>
        <div className={styles.kpiValueRow}>
          {score !== null && score !== undefined ? (
            <>
              <span className={styles.kpiDot} style={{ background: qualityColor(score) }} aria-hidden="true" />
              <span className={styles.kpiValue}>{Math.round(score)}</span>
              <span className={styles.kpiGrade}>{gradeOf(score)}</span>
              <Delta summary={summary} t={t} />
            </>
          ) : (
            <span className={styles.kpiEmpty}>{t("roadmap.kpi.noData")}</span>
          )}
        </div>
        <div className={styles.kpiSub}>
          {plural(t, "windows", summary.n || 0)} · {plural(t, "devices", summary.devices || 0)} · {plural(t, "impacts", summary.impacts || 0)}
        </div>
      </div>
      <div className={styles.kpiMini} style={{ cursor: "default" }}>
        <div className={styles.kpiLabel}>{t("roadmap.metrics.rms_v")}</div>
        <div className={styles.kpiMiniValue}>{summary.rms_v === null || summary.rms_v === undefined ? "—" : `${summary.rms_v.toFixed(2)} m/s²`}</div>
      </div>
    </div>
  );
}
